import React, { useState } from "react"
import ClientProjectChip from "../../../../components/molecules/ClientProjectChip.molecule"
import {
  getFavoriteActiveProjects,
  getTeamMemberActiveProjects,
  saveFavoriteProjects,
} from "../../../../services/project.service"
import useSessionContext from "../../../../hooks/contextConsumers/useSessionContext.hook"
import { OverlayPanel } from "../../../../components/atoms/OverlayPanel.atom"
import InlineMultiSelectDropdown from "../../../../components/molecules/InlineMultiSelectDropdown.molecule"
import Button from "../../../../components/atoms/Button.atom"
import { arraysContainSameNumbers } from "../../../../utils/arrays.utils"
import useEffectAfterMount from "../../../../hooks/useEffectAfterMount.hook"
import useMount from "../../../../hooks/useMount"

const MyProjects = ({
  onAccept,
  onCancel,
  optionValue = "projectID",
  optionLabel = "projectTagName",
}) => {
  const [allProjects, setAllProjects] = useState([])
  const [selectedProjects, setSelectedProjects] = useState([])
  const [bufferedSelectedProjects, setBufferedSelectedProjects] = useState([])
  const [submitting, setSubmitting] = useState(false)
  const [loading, setLoading] = useState(false)
  const { user } = useSessionContext()

  // useEffectAfterMount(() => {
  //   getProjectsForElement()
  // }, [])

  useMount(() => {
    getProjectsForElement()
  })

  const getProjectsForElement = async () => {
    setLoading(true)
    await gettingProjects()
    await gettingFavoriteProjects()
    setLoading(false)
  }
  const gettingProjects = async () => {
    try {
      const response = await getTeamMemberActiveProjects(user.teamMemberID)
      if (response?.result) {
        setAllProjects(response.result.filter((p) => p.projectID !== 1))
      }
    } catch (error) {
      console.error(error)
    }
  }
  const gettingFavoriteProjects = async () => {
    try {
      const response = await getFavoriteActiveProjects(user.teamMemberID)
      if (response?.result) {
        const withoutInt = response.result.filter((p) => p.projectID !== 1)
        setSelectedProjects(withoutInt.map((p) => p.projectID))
        setBufferedSelectedProjects(withoutInt.map((p) => p.projectID))
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <InlineMultiSelectDropdown
        value={bufferedSelectedProjects}
        options={allProjects}
        optionValue={optionValue}
        optionLabel={optionLabel}
        placeholder="Selecciona un proyecto"
        onChange={setBufferedSelectedProjects}
        hasSearchBar
        initiallyExpanded
        itemTemplate={(option) => {
          const current = allProjects?.find(
            (o) => o[optionValue] === option[optionValue]
          )
          if (!current) return null
          const { clientTagName, projectTagName, projectName } = current
          return (
            <div className="flex gap-2 align-items-center">
              <ClientProjectChip
                clientCode={clientTagName}
                projectCode={projectTagName}
              />
              <p
                className="text-overflow-ellipsis  overflow-hidden whitespace-nowrap"
                style={{ maxWidth: "320px" }}
                title={projectName}
              >
                {projectName}
              </p>
            </div>
          )
        }}
        loading={loading}
        selectedItemsLabel={
          <span>
            {bufferedSelectedProjects?.length} proyectos seleccionados
          </span>
        }
      />
      <div className="p-dialog-footer">
        <div className="flex gap-2">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button p-component p-button-secondary p-button-text border-round-3xl"
            onClick={() => {
              setBufferedSelectedProjects(selectedProjects)
              onCancel()
            }}
          />
          <Button
            label="Guardar"
            icon="pi pi-check"
            disabled={
              arraysContainSameNumbers(
                selectedProjects,
                bufferedSelectedProjects
              ) || submitting
            }
            className="bg-primary-highlight border-round-3xl"
            onClick={async () => {
              setSelectedProjects(bufferedSelectedProjects)
              setSubmitting(true)
              try {
                await saveFavoriteProjects(
                  user.teamMemberID,
                  bufferedSelectedProjects.map((p) => ({ projectID: p }))
                )
                onAccept()
              } catch (error) {
                console.error(error)
              }
              setSubmitting(false)
            }}
          />
        </div>
      </div>
    </>
  )
}

export default MyProjects
